<app-alerts></app-alerts>   

    <div class="streams-page"  *ngIf="stream$ | async as video; else loading" > 
   

        <app-video-overview  [video]="video"></app-video-overview>

 
     

</div> 
    
<ng-template #loading>
   <app-skeleton-page   [type]="'video'" ></app-skeleton-page> 

<!--
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
    <div style="margin: auto;"> 
         <app-loader></app-loader>
     </div>
    </div> -->
</ng-template> 
